import Table from './Table';
export default Table;
//# sourceMappingURL=index.js.map
